import React, { Component, Fragment } from "react";
import { FormattedMessage } from 'react-intl';
import { Field } from "formik";
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import { connect } from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";
import getCountries from '../../helpers/Countries';

class CountrySelectComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      focusedField: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps && nextProps.value !== prevState.value) {
      return {
        ...prevState,
        value: nextProps.value
      }
    }

    return prevState;
  }

  adjustSelectBorderRadius = () => {
    let elements = document.querySelector(".select2-dropdown");
    let initialClass = '';

    if (elements.length === 0) {
      return;
    }

    initialClass = elements.classList;

    if (initialClass.length === 0) {
      return;
    }

    let imageElem = document.querySelector(".select-addon .input-group-prepend .input-group-text")

    if (initialClass.contains('select2-dropdown--below')) {
      imageElem.classList.remove("no-top-radius");
      imageElem.classList.add("no-bottom-radius");
    }

    if (initialClass.contains('select2-dropdown--above')) {
      imageElem.classList.remove("no-bottom-radius");
      imageElem.classList.add("no-top-radius");
    }
  }

  render() {
    const countriesList = getCountries(this.props.currentLanguage);
    let countries = [];

    for (let countryCode in countriesList) {
      countries.push({id: countryCode, text: countriesList[countryCode]})
    }

    return (
      <FormGroup>
        <InputGroup className={`input-group-merge input-group-alternative select-addon select-${this.props.fieldName} ${this.props.errorClass ? this.props.errorClass : ''}`}>
          <FormattedMessage id={ this.props.label } >
            {
              placeholder => (
                <Field>
                  {
                    () => (
                      <Fragment>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            {
                              this.props.fontAwesome ?
                                <FontAwesomeIcon icon={ fontAwesome[this.props.fontAwesome] } /> :
                                <i className={ this.props.icon }/>
                            }
                          </InputGroupText>
                        </InputGroupAddon>
                        <Select2
                          id={'input-' + this.props.fieldName}
                          name={ this.props.fieldName }
                          defaultValue={ this.state.value }
                          placeholder={ placeholder }
                          className='form-control'
                          options={{
                            placeholder: placeholder[0]
                          }}
                          onOpen={ () => {
                            this.adjustSelectBorderRadius();
                            window.addEventListener('resize', this.adjustSelectBorderRadius);
                            window.addEventListener('scroll', this.adjustSelectBorderRadius);
                          }}
                          onClose={ () => {
                            let imageElem = document.querySelector(".select-addon .input-group-prepend .input-group-text");
                            if (imageElem.length !== 0) {
                              imageElem.classList.remove("no-top-radius");
                              imageElem.classList.remove("no-bottom-radius");
                            }

                            window.removeEventListener('resize', this.adjustSelectBorderRadius);
                            window.removeEventListener('scroll', this.adjustSelectBorderRadius);
                          }}
                          data={ countries }
                          onChange={
                            event => {
                              if (this.props.onChange) {
                                this.props.onChange(event);
                              }

                              this.setState({
                                value: event.target.value
                              });
                            }
                          }
                        />
                      </Fragment>
                    )
                  }
                </Field>
              )
            }
          </FormattedMessage>
        </InputGroup>
      </FormGroup>
    );
  }
}

CountrySelectComponent.defaultProps = {
  fieldName: 'companyCountry',
  label: 'fields.companyCountry',
  value: '',
  options: [],
  checked: false,
  currentLanguage: 'en',
};

const mapStateToProps = state => ({
  currentLanguage: state.locale.lang,
});

const CountrySelect = connect(mapStateToProps)(CountrySelectComponent);

export { CountrySelect, CountrySelectComponent };
